import axios, { AxiosError } from 'axios';

interface ApiError {
  message?: string;
}

export const backendAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

export const get_industries = async () => {
  try {
    const response = await backendAPI.get('industries/');
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get industry types failed');
  }
};